import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { useTranslation } from 'react-i18next';

import { orderBy } from 'lodash';

// icon
import { QualityIcon } from '../../assets/svg/Icon';

import Lists from './lists';
import Map from './map';
import WaterQualityLegend from './legend/WaterQualityLegend';
import Modal from '../../components/modal/Modal';
import ModeContext from '../../context/ModeContext';
import UserContext from '../../context/UserContext';

// style
import './styles.css';
import { globalStyle } from '../../global/style';

const useStyles = makeStyles(globalStyle);

export default function Main() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [, setError] = useState('');
  const [markers] = useState([]);
  const [keyLegend, setKeyLegend] = useState('กรด-ด่าง');
  const [map, setMap] = useState(null);
  const [getLastSearchWaterquality, setLastSearchWaterquality] = useState([]);
  const { currentMode, currentArea } = useContext(ModeContext);
  const { userIsLogin } = useContext(UserContext);
  const [modalData, setModalData] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });
  const [modalDataReset] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });
  // const unmounted = useRef(false);

  function resetModal() {
    setModalData(modalDataReset);
    modalData.open = false;
  }

  const handleSetMap = (mapRef) => {
    setMap(mapRef);
  };

  const handleChangeLegend = (data) => {
    setKeyLegend(data);
    setModalData(modalDataReset);
  };

  const handleSearchMarker = (id, lat, lng) => (e) => {
    // prevent default action
    e.preventDefault();
    // pan map to current marker position
    map.panTo([parseFloat(lat), parseFloat(lng)]);
    // open Popup
    const currentMarker = markers[id];
    // console.log('currentMarker ', currentMarker);
    if (currentMarker) {
      currentMarker.openPopup();
    }
  };

  function handleModalOpen(params) {
    setModalData(params);
  }

  // fetch data waterquality_load
  useEffect(() => {
    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_URL}/analyst/waterquality_load`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ....');
        })
        .then((result) => {
          // filter null and data not updated in 24 hrs
          // const currentDateTime = new Date();
          // const last24hrs = currentDateTime.setDate(
          //   currentDateTime.getDate() - 2,
          // );
          // sorting and filter
          const waterqualitySort = orderBy(
            result.data.data,
            ['waterquality_datetime'],
            ['desc'],
          );
          // const datasWaterquality = waterqualitySort.filter((d) => {
          //   const time = new Date(d.waterquality_datetime.replace(/-/g, '/')).getTime();
          //   return last24hrs < time;
          // });

          // replace value -9999 to null
          const datasWaterquality = waterqualitySort.map((d) => ({
            id: d.id,
            waterquality_id: d.waterquality_id,
            waterquality_datetime: d.waterquality_datetime,
            waterquality_do: d.waterquality_do !== -9999 ? d.waterquality_do : null,
            waterquality_ph: d.waterquality_ph !== -9999 ? d.waterquality_ph : null,
            waterquality_temp: d.waterquality_temp !== -9999 ? d.waterquality_temp : null,
            waterquality_turbid: d.waterquality_turbid !== -9999 ? d.waterquality_turbid : null,
            waterquality_bod: d.waterquality_bod !== -9999 ? d.waterquality_bod : null,
            waterquality_tcb: d.waterquality_tcb !== -9999 ? d.waterquality_tcb : null,
            waterquality_fcb: d.waterquality_fcb !== -9999 ? d.waterquality_fcb : null,
            waterquality_nh3n: d.waterquality_nh3n !== -9999 ? d.waterquality_nh3n : null,
            waterquality_wqi: d.waterquality_wqi !== -9999 ? d.waterquality_wqi : null,
            waterquality_ammonium: d.waterquality_ammonium !== -9999
              ? d.waterquality_ammonium : null,
            waterquality_nitrate: d.waterquality_nitrate !== -9999 ? d.waterquality_nitrate : null,
            waterquality_colorstatus: d.waterquality_colorstatus > 0
              ? d.waterquality_colorstatus : null,
            waterquality_status: d.waterquality_status,
            waterquality_salinity: d.waterquality_salinity !== -9999
              ? d.waterquality_salinity : null,
            waterquality_conductivity: d.waterquality_conductivity > 0
              ? d.waterquality_conductivity : null,
            waterquality_tds: d.waterquality_tds !== -9999 ? d.waterquality_tds : null,
            waterquality_chlorophyll: d.waterquality_chlorophyll !== -9999
              ? d.waterquality_chlorophyll : null,
            waterquality_station: d.waterquality_station,
            station_type: d.station_type,
            basin: d.basin,
          }));
          setLastSearchWaterquality(datasWaterquality);
        })
        .catch((err) => setError(err));
    };
    fetchData();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={2} id="waterQuality_main">
        <Grid item xs={12} sm={12} md={4}>
          <Box display="flex" alignItems="center">
            <Box display="flex" className={classes.shapeCircle} alignItems="center" justifyContent="center">
              <QualityIcon style={{ color: 'white' }} />
            </Box>
            <Box p={1}><Typography variant="h6" className={classes.titlePage}>{t('คุณภาพน้ำ')}</Typography></Box>
          </Box>
          <Box>
            <Map
              markers={markers}
              datas={getLastSearchWaterquality}
              handleSetMap={handleSetMap}
              handleModalOpen={handleModalOpen}
              handleChangeLegend={handleChangeLegend}
              currentMode={currentMode}
              currentArea={currentArea}
            />
            <WaterQualityLegend keyLegend={keyLegend} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <Box mt={7}>
            <Lists
              datas={getLastSearchWaterquality}
              handleSearchMarker={handleSearchMarker}
              currentMode={currentMode}
              currentArea={currentArea}
              userIsLogin={userIsLogin}
            />
          </Box>
        </Grid>
      </Grid>
      <Modal
        open={modalData.open}
        modalHeader={modalData.header}
        modalSubHeader={modalData.subheader}
        modalContent={modalData.content}
        resetModal={resetModal}
      />
    </div>
  );
}
